import { render, staticRenderFns } from "./AppPrivicy.vue?vue&type=template&id=6064c921&scoped=true&"
import script from "./AppPrivicy.vue?vue&type=script&lang=js&"
export * from "./AppPrivicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064c921",
  null
  
)

export default component.exports